import { Typography } from "@deere/fuel-react";
import {
  useState,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { log } from "../../Helper";
import _ from "lodash";
import moment from "moment";

import * as providerActionCreators from "../../load-build/orders/actions";
import { bindActionCreators } from "redux";
import { updateOrderPathTranposrtData } from "../api";
import { toast } from "react-toastify";

const TransportationContent = forwardRef((props, ref) => {
  const {
    tabValue,
    locationList,
    isEditClicked,
    logisticUnits,
    saveTransportData,
    setIsLoading,
    getShipToDetailsForMachine,
    orderUnit,
    orderNumber,
    isUserAdmin,
  } = props;

  const { load } = bindActionCreators(providerActionCreators, useDispatch());
  const pl = useSelector((storeState) => storeState.getProviderList);

  // provider list sorted
  const providerList = useMemo(
    () =>
      pl.sort(function (a, b) {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [pl]
  );

  // location list sorted. checked locationDesc field for null or undefined values
  const sortedLocationList = useMemo(
    () =>
      Array.isArray(locationList)
        ? [...locationList].sort((a, b) => {
            const aDesc = a?.locationDesc || "";
            const bDesc = b?.locationDesc || "";
            if (!aDesc && !bDesc) return 0;
            if (!aDesc) return 1;
            if (!bDesc) return -1;
            return aDesc.localeCompare(bDesc, "en", { sensitivity: "base" });
          })
        : [],
    [locationList]
  );

  // logistic units sorted
  const sortedLogisticUnits = useMemo(
    () =>
      logisticUnits.sort((a, b) => {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [logisticUnits]
  );

  const [isCostError, setCostError] = useState(false);

  let submitForm = "";

  const [formData, setFormData] = useState({
    logUnit: null,
    fromLocation: null,
    toLocation: null,
    forwarder: null,
    forwarderNtf: "",
    cost: 0,
    purchaseOrder: null,
    shippingOrder: null,
    shippingInstructions: null,
  });

  // keys map between formData and tabValue
  const keyMap = {
    purchaseOrder: "po",
    shippingOrder: "shippingOrder",
    shippingInstructions: "shippingInstructions",
    cost: "cost",
    forwarderNtf: "forwarderNtfStatus",
  };

  // useEffect for updating formData to set existing values
  useEffect(() => {
    if (isEditClicked) {
      setFormData((prev) => {
        const updated = { ...prev };
        Object.entries(keyMap).forEach(([formKey, tabKey]) => {
          updated[formKey] = tabValue[tabKey];
        });
        return updated;
      });

      const fromLoc = sortedLocationList.find(
        (l) => l.locationDesc === tabValue.start
      );
      setFormData((prev) => ({
        ...prev,
        fromLocation: fromLoc || null,
      }));

      const toLoc = sortedLocationList.find(
        (l) => l.locationDesc === tabValue.destination
      );
      setFormData((prev) => ({
        ...prev,
        toLocation: toLoc || null,
      }));

      const logUnit = sortedLogisticUnits.find(
        (l) => l.descr === tabValue.logUnit
      );
      setFormData((prev) => ({
        ...prev,
        logUnit: logUnit || null,
      }));

      const provider = providerList.find((p) => p.descr === tabValue.forwarder);
      setFormData((prev) => ({
        ...prev,
        forwarder: provider || null,
      }));
    }
  }, [isEditClicked]);

  //load all providers
  useEffect(function () {
    load();

    // set fromData to initial state when tab loads
    setFormData({
      logUnit: null,
      fromLocation: null,
      toLocation: null,
      forwarder: null,
      forwarderNtf: "",
      cost: 0,
      purchaseOrder: null,
      shippingOrder: null,
      shippingInstructions: null,
    });
  }, []);

  // handleChange function to update formData based on user input
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cost" && (_.isNull(value) || _.isEqual(value, ""))) {
      setCostError(true);
    } else {
      setCostError(false);
    }

    if (name === "provider") {
      const selectedProvider = providerList.find(
        (p) => p.providerId === Number(value)
      );
      setFormData((prev) => ({
        ...prev,
        forwarder: selectedProvider || null,
      }));
    } else if (name === "fromLocation") {
      const selectedLocation = sortedLocationList.find(
        (l) => l.locationId === Number(value)
      );
      setFormData((prev) => ({
        ...prev,
        fromLocation: selectedLocation || null,
      }));
    } else if (name === "toLocation") {
      const selectedLocation = sortedLocationList.find(
        (l) => l.locationId === Number(value)
      );
      setFormData((prev) => ({
        ...prev,
        toLocation: selectedLocation || null,
      }));
    } else if (name === "logUnit") {
      const selectedLogUnit = sortedLogisticUnits.find(
        (l) => l.logUnitId === Number(value)
      );
      setFormData((prev) => ({
        ...prev,
        logUnit: selectedLogUnit || null,
      }));
    } else if (name === "cost") {
      setFormData((prev) => ({
        ...prev,
        cost: Number(value),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleFormSubmit = async (event) => {
    if (!isUserAdmin) {
      toast.error("You do not have permission to save transport data");
      return;
    }

    event.preventDefault();
    setIsLoading(true);

    try {
      let tranportObj = {
        orderPathId: tabValue.orderPathId,
        fromLocationId: formData.fromLocation?.locationId || 0,
        toLocationId: formData.toLocation?.locationId || 0,
        logUnitId: formData.logUnit?.logUnitId || 0,
        // frwdNtfStatus: _.isEqual(formData.forwarderNtf, '') ? ((!_.isNull(tabValue.forwarderNtf) && !_.isEmpty(tabValue.forwarderNtf)) ? 'PRO' : 'YES') : formData.forwarderNtf,
        frwdNtfStatus: _.isEqual(formData.forwarderNtf, "")
          ? ""
          : _.isNull(formData.forwarderNtf)
          ? ""
          : formData.forwarderNtf,
        poStatus:
          _.isEmpty(formData.purchaseOrder) || _.isNull(formData.purchaseOrder)
            ? "NULL"
            : "PRO",
        forwarderId: formData.forwarder?.providerId || 0,
        cost: formData.cost,
        purchaseOrder: formData.purchaseOrder,
        shippingOrder: formData.shippingOrder,
        shippingInstructions: formData.shippingInstructions,
        orderUnit: orderUnit,
        orderNumber: orderNumber
      }

      const response = await updateOrderPathTranposrtData(tranportObj);
      if (response.status === 200) {
        toast.success(response.data.message);
        setIsLoading(false);
        getShipToDetailsForMachine([orderUnit, orderNumber].join(""));
      } else if (response.status === 304) {
        toast.warn("Please update any field before saving");
        setIsLoading(false);
      } else {
        toast.error(response.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      log(
        "error occurred while updating transport data for orderPath-- ",
        tabValue.orderPathId
      );
      setIsLoading(false);
    }
  };

  const handleSave = () => {
    console.log("TransportationContent => handleSave called");

    submitForm.click();
  };

  useImperativeHandle(
    ref,
    () => ({
      handleSave,
    }),
    [handleSave]
  );

  return (
    <div>
      <form
        id="trasport-form-tag"
        onSubmit={handleFormSubmit}
        className="text-md"
      >
        <div className="flex flex-col gap-3 h-[300px]">
          <div className="flex">
            {/* Start */}
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                Start
              </Typography>
              {isEditClicked ? (
                <select
                  name="fromLocation"
                  value={formData.fromLocation?.locationId || ""}
                  onChange={handleChange}
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                >
                  <option value="">Select Start</option>
                  {sortedLocationList.map((loc) => (
                    <option key={loc.locationId} value={loc.locationId}>
                      {loc.locationDesc}
                    </option>
                  ))}
                </select>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.start}
                </Typography>
              )}
            </div>

            {/* Destination  */}
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                Destination
              </Typography>
              {isEditClicked ? (
                <select
                  name="toLocation"
                  value={formData.toLocation?.locationId}
                  onChange={handleChange}
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                >
                  <option value="">Select Destination</option>
                  {sortedLocationList.map((loc) => (
                    <option key={loc.locationId} value={loc.locationId}>
                      {loc.locationDesc}
                    </option>
                  ))}
                </select>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.destination}
                </Typography>
              )}
            </div>

            {/* Logistic unit */}
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                Logistic Unit
              </Typography>
              {isEditClicked ? (
                <select
                  name="logUnit"
                  value={formData.logUnit?.logUnitId}
                  onChange={handleChange}
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                >
                  <option value="">Select LogUnit</option>
                  {sortedLogisticUnits.map((log) => (
                    <option key={log.logUnitId} value={log.logUnitId}>
                      {log.descr}
                    </option>
                  ))}
                </select>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.logUnit}
                </Typography>
              )}
            </div>
          </div>

          {/* Cost */}
          <div className="flex">
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                Freight Rate
              </Typography>
              {isEditClicked ? (
                <>
                  <input
                    id="transport-form-input-cost"
                    // className="text-xs ml-[6%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px]"
                    className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                    name="cost"
                    // defaultValue={tabValue.cost}
                    value={formData.cost}
                    type="number"
                    onChange={handleChange}
                  ></input>
                  {isCostError && (
                    <p
                      id="transport-form-err"
                      className="text-xs text-red-500 ml-[40%] mb-[-5%]"
                    >
                      Cost is invalid
                    </p>
                  )}
                </>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.cost}
                </Typography>
              )}
            </div>

            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Currency
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {tabValue.currency}
              </Typography>
            </div>

            {/* PO */}
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                PO
              </Typography>
              {isEditClicked ? (
                <input
                  id="transport-form-input-po"
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                  name="purchaseOrder"
                  // defaultValue={tabValue.po}
                  value={formData.purchaseOrder}
                  type="text"
                  onChange={handleChange}
                ></input>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.po}
                </Typography>
              )}
            </div>
          </div>

          {/* Forwarder  */}
          <div className="flex">
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                Forwarder
              </Typography>
              {isEditClicked ? (
                <select
                  name="provider"
                  value={formData.forwarder?.providerId || ""}
                  onChange={handleChange}
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                >
                  <option value="">Select forwarder</option>
                  {providerList.map((provider) => (
                    <option
                      key={provider.providerId}
                      value={provider.providerId}
                    >
                      {provider.descr}
                    </option>
                  ))}
                </select>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.forwarder}
                </Typography>
              )}
            </div>

            {/* Forwarder notification time */}
            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Forwarder Notification
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {null != tabValue.forwarderNtf &&
                !_.isEmpty(tabValue.forwarderNtf)
                  ? moment(tabValue.forwarderNtf).format("YYYY-MM-DD HH:mm:ss")
                  : ""}
              </Typography>
            </div>

            {/* Foewarder notification status */}
            <div className="flex flex-col gap-1 w-[300px] pr-[1%]">
              <Typography fontWeight={"700"} fontSize={14}>
                Forwarder Notification
              </Typography>
              {isEditClicked ? (
                <select
                  name="forwarderNtf"
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                  value={formData.forwarderNtf}
                  // disabled={!_.isEmpty(tabValue.forwarderNtf) ? false : true}
                  onChange={handleChange}
                >
                  <option value="">Select Notification Status</option>
                  <option key={1} value={"YES"}>
                    YES
                  </option>
                  <option key={2} value={"PRO"}>
                    PRO
                  </option>
                </select>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {/* {!_.isEmpty(tabValue.forwarderNtf) ? 'PRO' : 'YES'} */}
                  {tabValue.forwarderNtfStatus}
                </Typography>
              )}
            </div>
          </div>

          {/* Shipping order */}
          <div className="flex">
            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Shipping Order
              </Typography>
              {isEditClicked ? (
                <input
                  id="transport-form-input-so"
                  className="border-[1px] p-[3px] w-[280px] border-gray-500 rounded-sm"
                  name="shippingOrder"
                  // defaultValue={tabValue.shippingOrder}
                  value={formData.shippingOrder}
                  type="text"
                  onChange={handleChange}
                ></input>
              ) : (
                <Typography fontWeight="400" fontSize={16}>
                  {tabValue.shippingOrder}
                </Typography>
              )}
            </div>

            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Loading Date
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {tabValue.loadingDate}
              </Typography>
            </div>
          </div>

          {/* Freetext */}
          <div>
            <div className="flex flex-col gap-1 mt-2 max-w-[800px] w-full">
              <Typography fontWeight={"700"} fontSize={14}>
                Shipping Free Text
              </Typography>
              {isEditClicked ? (
                <textarea
                  id="transport-form-input-so"
                  className="border-[1px] p-[3px] border-gray-500 rounded-sm w-full resize-none"
                  name="shippingInstructions"
                  value={formData.shippingInstructions}
                  onChange={handleChange}
                  style={{
                    minHeight: "48px",
                    maxHeight: "120px",
                    overflowY: "auto",
                    wordBreak: "break-word",
                    borderRadius: "0.375rem",
                  }}
                />
              ) : (
                <div
                  className={`w-full max-w-[800px] max-h-[80px] overflow-y-auto break-words rounded-md ${
                    tabValue.shippingInstructions
                      ? "border border-gray-200 p-2 bg-gray-50"
                      : "border-0 p-0 bg-transparent"
                  }`}
                >
                  <Typography fontWeight="400" fontSize={16}>
                    {tabValue.shippingInstructions}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
        <input
          id="transport-form-submit-btn"
          className="invisible"
          ref={(input) => {
            submitForm = input;
          }}
          type="submit"
        />
      </form>
    </div>
  );
});

export default TransportationContent;
